import React from 'react';
import Settings from '../components/Settings'


function SettingsPage() {
	return (
		<>
			<Settings />
		</>
	);
}

export default SettingsPage;